module.exports = __webpack_public_path__ + "static/img/jl-drgs.9942883.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/jl-drgs.jpg
// module id = e5fw
// module chunks = 1